import React, { useEffect } from 'react';
import Banner from './Banner';
import Categories from './Categories';
import GameList from './GameList';
import GameListCarousel from './GameListCarousel';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getCasinoProviders } from '../../store/actions/casino.actions';
import AdSponsor from '../AdSponsor';
import { NavLink } from 'react-router-dom';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import GameListCarouselDynamic from './GameListCarouselDynamic';
import NewLoading from '../../Components/Common/NewLoading';
import CustomModal from './CustomModal'
import Util from '../../helper/Util';
import { Translate } from '../../localization';
const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 8,
    slidesToScroll: 6,
    margin: 10,
    prevArrow: <button><NavigateBeforeRoundedIcon /></button>,
    nextArrow: <button><NavigateNextRoundedIcon /></button>,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 4,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
    ],
};

const myStyles = {
    fontSize: '20px',
    textAlign: 'center',
  };

const Casino = () => {

    const dispatch = useDispatch();

    const { casinoProviders, casinoSearchValue } = useSelector((state) => state.casino);

    useEffect(() => {
        dispatch(getCasinoProviders());
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute('lang', Translate.getLanguage());
        document.title = Translate.DocumentHeader;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute(
                'content',
                Translate.DocumentDescription
            );
        }
        const canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.setAttribute(
                'href',
                `https://www.jackpotct.com/${Translate.getLanguage()}/d/casino`
            );
        }

    }, []);
    return (

        <div id='scrollableDiv' className='casino-body'>
            <div className="banner-categories">
                <div className="casino-bg casino-parent-div casino-width-align">
                    <div class="container scrool-text">
                        <div class="heading-row">
                            <div class="announcement-icon-box">
                                <div class="announcement-icon">
                                    <img title="Announcement icon" alt="info" src="//images.ctfassets.net/scslmvjv6lim/OF1lF3nDKZKY2259lbmQa/af118f3cbeff2033175ebdd31ab7e37c/annon.svg" />
                                </div>
                            </div>
                            <div class="announcement-text">
                          {Translate.announceMsg} 
                            </div>
                        </div>
                    </div>
                </div>
                <Banner />
            </div>

            <div className="about-footer">
                <h1 style={myStyles}>{Translate.DocumentHeader}</h1>
            </div>

            <div className='w-100'>
                <Categories />
                {casinoSearchValue.length == 0 ?
                    <>
                        <GameListCarouselDynamic name='new' title='New' />
                        <GameListCarouselDynamic name='most_popular' title='Hot Games' />
                        <GameListCarousel
                            category={'SLOT'}
                        />
                        <GameListCarousel
                            category={'CRASH'}
                        />
                        <GameListCarousel
                            category={'TABLEGAME'}
                        />
                        <GameListCarouselDynamic name='chinese' title='Chinese' />
                        <GameListCarouselDynamic name='bonus buy' title='Bonus Buy' />
                        <GameListCarousel
                            category={'INSTANTWIN'}
                        />
                        <div className='top-provider-heading'>
                            <div className="inner-heading-left d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <img className="casino-category-img" src="/img/SVG/PROVIDERS.svg" alt="Providers" />
                                    <p>{Translate.tabNames['Top Providers']}</p>
                                </div>
                                <NavLink to={`/${Translate.getLanguage()}/d/casino/providers`} className="viewAllBtn">{Translate.viewall}</NavLink>
                            </div>
                        </div>
                        <div className='top-provider-slider'>
                            {casinoProviders.length === 0 ? <NewLoading />
                                : <Slider {...settings} >
                                    {casinoProviders?.slice(0, 15).map((provider, index) => {
                                        return (
                                            <NavLink className='top-provider-card cursor-pointer' key={index} to={`/${Translate.getLanguage()}/d/casino/providers/${provider[0]}`}>
                                              <img src={`/img/Providers/${provider[1]}.png`} alt="Provider's Image" />
                                            </NavLink>
                                        );
                                    })}
                                </Slider>
                            }
                        </div>
                    </>
                    :
                    <GameList home={true} />
                }
            </div>
        </div>
    );
};

export default Casino;
